!function() {
  "use strict";
  const e = /* @__PURE__ */ new Map(), r = (e2) => Date.now() - e2 > 3e5, t = async ({ shopDomain: e2, accessToken: r2, query: t2, variables: a2 }) => {
    try {
      const i2 = `https://${e2}/api/2024-07/graphql.json`, n2 = { "X-Shopify-Storefront-Access-Token": r2, "Content-Type": "application/json" }, c2 = await fetch(i2, { method: "POST", headers: n2, body: JSON.stringify({ query: t2, variables: a2 }) });
      return await c2.json();
    } catch (e3) {
      throw console.log("error", e3), e3;
    }
  }, a = async (a2, c2, o2, l2, s2, u) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
    const p = ((e2, r2, t2, a3, i2) => `${e2}:${r2}:${t2}:${JSON.stringify(a3)}:${i2}`)(a2, o2, l2, s2, u), d = e.get(p);
    if (d && !r(d.timestamp)) return d.data;
    try {
      let r2, d2 = true, y = [];
      for (; d2; ) {
        const e2 = await t({ shopDomain: a2, accessToken: c2, query: `query fetchProductVariantMetafield($handle: String!, $country: CountryCode) @inContext(country: $country){
                    product(handle: $handle) {
                        title
                        handle
                        variants(first: 250,after: ${r2 ? `"${r2}"` : "null"}){
                            edges{
                                node{
                                    id
                                    title
                                    metafield(namespace: "app--173437812737--clay", key: "pricing_rule"){
                                        value
                                        type
                                    }
                                    price{
                                      amount
                                      currencyCode
                                    }
                                    compareAtPrice{
                                      amount
                                      currencyCode
                                    }
                                }
                            }
                            pageInfo{
                                hasNextPage
                                endCursor
                            }
                        }
                    }
                }`, variables: { handle: o2, country: u } });
        if (!((_a = e2.data) == null ? void 0 : _a.product)) return d2 = false, console.log("No products found"), [];
        const n2 = (_d = (_c = (_b = e2.data) == null ? void 0 : _b.product) == null ? void 0 : _c.variants) == null ? void 0 : _d.edges.map((e3) => {
          var _a2;
          const r3 = e3.node, t2 = r3.id.split("/").pop(), a3 = (_a2 = r3.metafield) == null ? void 0 : _a2.value, n3 = i("string" == typeof a3 ? JSON.parse(a3) : []);
          let c3 = n3.find((e4) => e4.customerGroupId === l2 && !["LOGGED_IN", "ALL"].includes(l2) || s2.includes(e4.customerTag));
          c3 || "ALL" === l2 || (c3 = n3.find((e4) => "LOGGED_IN" === e4.customerGroupId)), c3 || "ALL" !== l2 || (c3 = n3.find((e4) => "ALL" === e4.customerGroupId));
          const o3 = window.clayMarketHandle;
          window.clayCountryCurrency;
          if (c3) {
            let e4 = c3.markets.find((e5) => e5.handle === o3 || "" === e5.handle) || null;
            if (e4) {
              const a4 = { ...c3, markets: [e4] };
              if ("" === a4.ownerId || a4.ownerId === t2.split("/").pop()) return { id: t2, title: r3.title, pricingRule: a4, price: r3.price, compareAtPrice: r3.compareAtPrice };
            }
          }
          return { id: t2, title: r3.title, pricingRule: null, price: r3.price, compareAtPrice: r3.compareAtPrice };
        });
        y.push(...n2), d2 = (_h = (_g = (_f = (_e = e2.data) == null ? void 0 : _e.product) == null ? void 0 : _f.variants) == null ? void 0 : _g.pageInfo) == null ? void 0 : _h.hasNextPage, r2 = (_l = (_k = (_j = (_i = e2.data) == null ? void 0 : _i.product) == null ? void 0 : _j.variants) == null ? void 0 : _k.pageInfo) == null ? void 0 : _l.endCursor;
      }
      const m = { handle: o2, allVariants: y };
      return e.set(p, { data: m, timestamp: Date.now() }), n(), m;
    } catch (e2) {
      throw console.error("Error fetching product metafield:", e2), e2;
    }
  };
  function i(e2) {
    if (!Array.isArray(e2) || 0 === e2.length) return [];
    const r2 = e2[0];
    return "customerGroupId" in r2 ? (t2 = e2, Array.isArray(t2) ? t2.map((e3 = {}) => {
      const { customerGroupId: r3 = "", customerTag: t3 = "", type: a2 = "WHOLESALE", wholesalePrice: i2 = null, quantityPrice: n2 = {} } = e3;
      let c2 = false;
      "QUANTITY" === a2 && (c2 = !!n2.isVariantUnique);
      let o2 = [];
      return "WHOLESALE" === a2 && null != i2 ? o2.push({ quantity: "1", price: i2 }) : Array.isArray(n2.value) && (o2 = n2.value), { ownerId: "", customerGroupId: r3, customerTag: t3, markets: [{ handle: "", currency: "", pricing: { type: o2.length > 1 ? "QUANTITY" : "WHOLESALE", strategy: "A", isVariantUnique: c2, priceSource: "R", values: o2 } }] };
    }) : []) : "i" in r2 ? function(e3) {
      if (!e3 || !Array.isArray(e3)) return null;
      return e3.map((e4 = {}) => {
        let r3 = e4.o || "", [t3 = "", a2 = ""] = (e4.i || "").split("~");
        return { ownerId: r3, customerGroupId: t3, customerTag: a2, markets: e4.p.split("|").map((e5) => {
          let [r4 = "", t4 = "", a3 = "A", i2 = "0", n2 = "R", c2 = ""] = e5.split("~"), o2 = c2.split(";").map((e6) => {
            let [r5 = "1", t5 = "0"] = e6.split(":");
            return { quantity: r5, price: t5 };
          }) ?? [];
          return { handle: r4, currency: t4, pricing: { type: o2.length > 1 ? "QUANTITY" : "WHOLESALE", strategy: a3, priceSource: n2, isVariantUnique: "1" === i2, values: o2 } };
        }) };
      });
    }(e2) : [];
    var t2;
  }
  const n = () => {
    for (const [t2, a2] of e.entries()) r(a2.timestamp) && e.delete(t2);
  };
  function c(e2, r2) {
    if (null === e2) return "";
    const t2 = "string" == typeof e2 ? parseFloat(e2) : e2, a2 = t2.toFixed(2), i2 = t2.toFixed(0), n2 = a2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), c2 = i2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return r2.replace("{{amount}}", a2).replace("{{amount_no_decimals}}", i2).replace("{{amount_with_comma_separator}}", n2).replace("{{amount_no_decimals_with_comma_separator}}", c2);
  }
  function o(e2, r2, t2) {
    var _a;
    let a2 = "", i2 = "", n2 = "", o2 = "", l2 = ((_a = e2.pricingRule) == null ? void 0 : _a.markets[0]) ?? null;
    if (!l2) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
    let s2 = l2.pricing.type;
    return "QUANTITY" === s2 ? { retailPriceText: a2, compareAtPriceText: i2, savingsText: n2, maxRetailPriceText: o2 } = function(e3, r3, t3, a3) {
      let i3 = a3.pricing.strategy, n3 = a3.pricing.values, o3 = a3.currency, l3 = e3.price.currencyCode, s3 = "R" === a3.pricing.priceSource ? e3.price.amount : "C" === a3.pricing.priceSource ? e3.compareAtPrice.amount : e3.price.amount, u = window.marketConversionRate;
      if (!s3 || "" === s3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      let p = n3.filter((e4) => Number(e4.quantity) <= t3).reduce((e4, r4) => Number(r4.quantity) > Number(e4.quantity) ? r4 : e4, { price: "0", quantity: "0" }).price;
      if (o3 !== l3 && "" !== o3) {
        if (!u || !u.conversion_rate) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
        ["A", "F"].includes(i3) && (p = (parseFloat(p) * u.conversion_rate).toFixed(2).toString());
      }
      let d = "A" === i3 ? p : "P" === i3 ? (parseFloat(s3) * (1 - parseFloat(p) / 100)).toFixed(2).toString() : "F" === i3 ? (parseFloat(s3) - parseFloat(p)).toFixed(2).toString() : e3.price.amount;
      if ("" === o3 && u && u.base_currency !== l3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      (parseFloat(d) < 0 || parseFloat(d) > parseFloat(e3.price.amount)) && (d = e3.price.amount);
      let y = c(d, clayProductPriceConfig.priceDisplayText), m = c(s3, clayProductPriceConfig.compareAtPriceDisplayText), P = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(s3) - parseFloat(d)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(s3) - parseFloat(d)) / parseFloat(s3) * 100).toFixed(0) : 0, g = c(P, clayProductPriceConfig.savingsDisplayText);
      return u && (y = window.clayCurrencySymbol + parseFloat(d).toFixed(2) + " " + window.clayCountryCurrency, m = window.clayCurrencySymbol + parseFloat(s3).toFixed(2) + " " + window.clayCountryCurrency, g = "Save " + ("amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? window.clayCurrencySymbol + P + " " + window.clayCountryCurrency : "percentage" === clayProductPriceConfig.savingsDisplayType ? P + "%" : "")), { retailPriceText: y, compareAtPriceText: m, savingsText: g, maxRetailPriceText: "" };
    }(e2, 0, t2, l2) : "WHOLESALE" === s2 && ({ retailPriceText: a2, compareAtPriceText: i2, savingsText: n2, maxRetailPriceText: o2 } = function(e3, r3, t3) {
      let a3 = t3.pricing.strategy;
      t3.pricing.values;
      let i3 = t3.currency, n3 = e3.price.currencyCode, o3 = window.marketConversionRate, l3 = "R" === t3.pricing.priceSource ? e3.price.amount : "C" === t3.pricing.priceSource ? e3.compareAtPrice.amount : e3.price.amount, s3 = t3.pricing.values[0].price;
      if (!l3 || "" === l3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      if (i3 !== n3 && "" !== i3) {
        if (!o3 || !o3.conversion_rate) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
        ["A", "F"].includes(a3) && (s3 = (parseFloat(s3) * o3.conversion_rate).toFixed(2).toString());
      }
      let u = "A" === a3 ? s3 : "P" === a3 ? (parseFloat(l3) * (1 - parseFloat(s3) / 100)).toFixed(2).toString() : "F" === a3 ? (parseFloat(l3) - parseFloat(s3)).toFixed(2).toString() : e3.price.amount;
      if ("" === i3 && o3 && o3.base_currency !== n3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      (parseFloat(u) < 0 || parseFloat(u) > parseFloat(e3.price.amount)) && (u = e3.price.amount);
      let p = c(u, clayProductPriceConfig.priceDisplayText), d = c(l3, clayProductPriceConfig.compareAtPriceDisplayText), y = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(l3) - parseFloat(u)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(l3) - parseFloat(u)) / parseFloat(l3) * 100).toFixed(0) : 0, m = c(y, clayProductPriceConfig.savingsDisplayText);
      return o3 && (p = window.clayCurrencySymbol + parseFloat(u).toFixed(2) + " " + window.clayCountryCurrency, d = window.clayCurrencySymbol + parseFloat(l3).toFixed(2) + " " + window.clayCountryCurrency, m = "Save " + ("amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? window.clayCurrencySymbol + y + " " + window.clayCountryCurrency : "percentage" === clayProductPriceConfig.savingsDisplayType ? y + "%" : "")), { retailPriceText: p, compareAtPriceText: d, savingsText: m, maxRetailPriceText: "" };
    }(e2, 0, l2)), { retailPriceText: a2, compareAtPriceText: i2, savingsText: n2, maxRetailPriceText: o2 };
  }
  async function l() {
    s({ productGrid: ".spf-product-card", productGridProductUrl: ".boost-kategorie-produkt-name a", productGridProductPrice: ".boost-kategorie-produkt-price", retailPriceBlockFormatOnCollectionsPage: "<span>{retailPriceText}</span>", comparePriceBlockFormatOnCollectionsPage: '<span>{retailPriceText} </span><span style="text-decoration: line-through;">{compareAtPriceText}</span>' }, 0, 1e4, 0);
  }
  function s(e2, r2, t2, i2) {
    let n2 = document.querySelectorAll(e2.productGrid);
    n2 = Array.from(n2).filter((r3) => {
      const t3 = r3.querySelector(e2.productGridProductPrice);
      return t3 && !t3.classList.contains("clay-wholesale-price");
    }), n2 && n2.length > 0 && n2.length !== i2 && function(e3, r3) {
      e3.forEach(async (e4, t3) => {
        let i3 = function(e5) {
          if (!e5 || "" === e5) return null;
          let r4 = null;
          const t4 = e5.match(/\/products\/([^/?#]+)/);
          return t4 && t4[1] && (r4 = decodeURIComponent(t4[1])), r4;
        }(e4.querySelector(r3.productGridProductUrl).href);
        const n3 = e4.querySelector(r3.productGridProductPrice);
        if (!n3 || n3.classList.contains("clay-wholesale-price")) return;
        const c2 = await async function(e5) {
          const r4 = window.clayStorefrontConfig || {}, t4 = window.clayCustomerTier || {}, i4 = window.clayCustomerTags || [], n4 = window.clayCountryIsoCode, { allVariants: c3 } = await a(r4.shopDomain, r4.token, e5, "" === t4.customerGroupId ? "LOGGED_IN" : t4.customerGroupId, i4, n4);
          return c3;
        }(i3);
        !async function(e5, r4, t4) {
          e5.sort((e6, r5) => parseFloat(e6.price.amount) - parseFloat(r5.price.amount));
          const a2 = e5[0];
          if (!a2.pricingRule) return;
          const i4 = r4.querySelector(t4.productGridProductPrice), { retailPriceText: n4, compareAtPriceText: c3, savingsText: l2, maxRetailPriceText: s2 } = o(a2, 0, 1);
          if ("" === n4) return;
          const u = function(e6, r5, t5, a3) {
            if (r5.comparePriceBlockFormatOnCollectionsPage && t5 !== a3) return r5.comparePriceBlockFormatOnCollectionsPage;
            if (r5.comparePriceBlockFormatOnProductPage && t5 !== a3) return r5.comparePriceBlockFormatOnProductPage;
            return r5.retailPriceBlockFormatOnCollectionsPage || r5.retailPriceBlockFormatOnProductPage || "{retailPriceText}";
          }(0, t4, n4, c3);
          let p = function(e6, r5, t5, a3, i5) {
            return e6.replace("{retailPriceText}", r5).replace("{compareAtPriceText}", t5).replace("{savingsText}", a3).replace("{maxRetailPriceText}", i5);
          }(u, n4, c3, l2, s2);
          i4.classList.contains("clay-wholesale-price") || (i4.innerHTML = p, i4.classList.add("clay-wholesale-price"));
        }(c2, e4, r3);
      });
    }(n2, e2), r2 < t2 && setTimeout(() => {
      s(e2, r2 + 200, t2, n2.length);
    }, 200);
  }
  !function() {
    window.addEventListener("popstate", l);
    const e2 = history.pushState;
    history.pushState = function() {
      e2.apply(this, arguments), l();
    };
    const r2 = history.replaceState;
    history.replaceState = function() {
      r2.apply(this, arguments), l();
    }, l();
  }();
}();
